module.exports = __webpack_public_path__ + "static/media/GBR Care (CBN Main Network) - GBR Care Main - 04-06-2024 N.64d7a242.gif";